import React from 'react';
import { Grid, Card, CardContent, Typography } from '@mui/material';

const classes = {
    root: {
        flexGrow: 1,
        padding: '20px',
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    },
    title: {
        marginBottom: '10px',
        textAlign: 'center',
    },
};

const Dashboard = () => {
    return (
        <div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography variant="h6" className={classes.title}>
                                Schools
                            </Typography>
                            <Typography>
                                10
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography variant="h6" className={classes.title}>
                                Schools
                            </Typography>
                            <Typography>
                                10
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography variant="h6" className={classes.title}>
                                Card 1
                            </Typography>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris sit
                                amet metus a nulla cursus eleifend at nec lectus.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography variant="h6" className={classes.title}>
                                Card 1
                            </Typography>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris sit
                                amet metus a nulla cursus eleifend at nec lectus.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>


                {/* Add more cards here */}

            </Grid>
        </div>
    );
};

export default Dashboard;